module.exports = __webpack_public_path__ + "static/media/seamless.76166232.svg";